var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { defaultApiVersion } from '../provideEndpoints';
import { getClientSdk } from '../utils/getClientSdk';
/**
 * An implementation of QuestionSubmissionService which hits LiveAPI.
 *
 * @internal
 */
var QuestionSubmissionServiceImpl = /** @class */ (function () {
    function QuestionSubmissionServiceImpl(config, httpService, apiResponseValidator) {
        this.config = config;
        this.httpService = httpService;
        this.apiResponseValidator = apiResponseValidator;
        this.endpoint = this.config.endpoints.questionSubmission;
    }
    QuestionSubmissionServiceImpl.prototype.submitQuestion = function (request) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var queryParams, body, response, _b, validationResult;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        queryParams = __assign(__assign(__assign({ v: defaultApiVersion }, ('apiKey' in this.config && { api_key: this.config.apiKey })), { sessionTrackingEnabled: request.sessionTrackingEnabled }), (_a = this.config) === null || _a === void 0 ? void 0 : _a.additionalQueryParams);
                        body = {
                            email: request.email,
                            entityId: request.entityId,
                            name: request.name,
                            questionDescription: request.questionDescription,
                            questionLanguage: this.config.locale,
                            questionText: request.questionText,
                            site: 'FIRSTPARTY'
                        };
                        if (!('token' in this.config)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.httpService.post(this.endpoint, queryParams, body, getClientSdk(request.additionalHttpHeaders), this.config.token)];
                    case 1:
                        _b = _c.sent();
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, this.httpService.post(this.endpoint, queryParams, body, getClientSdk(request.additionalHttpHeaders))];
                    case 3:
                        _b = _c.sent();
                        _c.label = 4;
                    case 4:
                        response = _b;
                        validationResult = this.apiResponseValidator.validate(response);
                        if (validationResult instanceof Error) {
                            return [2 /*return*/, Promise.reject(validationResult)];
                        }
                        return [2 /*return*/, {
                                uuid: response.meta.uuid
                            }];
                }
            });
        });
    };
    return QuestionSubmissionServiceImpl;
}());
export { QuestionSubmissionServiceImpl };
//# sourceMappingURL=QuestionSubmissionServiceImpl.js.map